module.exports = __webpack_public_path__ + "img/Zöpfe.502d74fc.jpg";